import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";

const SERVICES = [
  { title: "Full Home Turnkey", price: "From ₹12L", img: "https://images.pexels.com/photos/33685860/pexels-photo-33685860.jpeg",
    desc: "End-to-end interior delivery — design, civil, carpentry, electricals, painting, decor & handover. One contract, one timeline.", scope: ["3D Design & Drawings", "Civil & Plumbing", "Modular Carpentry", "Electricals & Lighting", "Painting & Polish", "Decor & Styling"] },
  { title: "Modular Kitchen", price: "From ₹2.8L", img: "https://images.pexels.com/photos/19836790/pexels-photo-19836790.jpeg",
    desc: "Handleless, Hettich-fitted modular kitchens with quartz/granite tops. Designed for Bengaluru humidity & Indian cooking.", scope: ["L / U / Island Layouts", "Quartz or Granite Tops", "Hettich / Hafele Hardware", "Soft-close Drawers", "Tall Pantry Units", "10-yr Warranty"] },
  { title: "Wardrobes & Storage", price: "From ₹1.2L", img: "https://images.pexels.com/photos/33599113/pexels-photo-33599113.jpeg",
    desc: "Floor-to-ceiling wardrobes in laminate, veneer or PU. Designed around your wardrobe inventory, not a catalog.", scope: ["Sliding / Openable", "Loft Units", "Internal Lighting", "Mirror & Dresser", "Acrylic / PU Finishes"] },
  { title: "False Ceiling & Lighting", price: "From ₹350/sqft", img: "https://images.unsplash.com/photo-1699239116624-85268dce7377?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBpbnRlcmlvciUyMGRlc2lnbnxlbnwwfHx8fDE3ODIzNjQ2NzZ8MA&ixlib=rb-4.1.0&q=85",
    desc: "Gypsum false ceiling with cove and spotlight provisions, finished with putty and paint for a clean, complete ceiling finish.", scope: ["Gypsum False Ceiling", "Cove Lighting", "Spotlight Provisions", "Putty & Paint Finish"] },
];

export default function Services() {
  return (
    <div data-testid="services-page" className="px-6 md:px-12 lg:px-24 py-24 md:py-32">
      <div className="max-w-4xl">
        <p className="overline">Services</p>
        <h1 className="font-heading text-5xl sm:text-7xl font-light tracking-[-0.02em] mt-5 leading-[1.02]">
          Considered craft. <em className="italic">End to end.</em>
        </h1>
        <p className="mt-7 text-lg text-[#5C5752] leading-[1.85] font-light max-w-2xl">
          From a single modular kitchen to a 4BHK turnkey home — every project is delivered by one project lead, one timeline, and one accountable team.
        </p>
      </div>

      <div className="mt-20 space-y-24 md:space-y-36">
        {SERVICES.map((s, i) => (
          <article key={s.title} data-testid={`service-${i}`} className={`grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16 items-center ${i % 2 ? "md:[&>div:first-child]:order-2" : ""}`}>
            <div className="md:col-span-7">
              <div className="img-zoom rounded-img-lg">
                <img src={s.img} alt={s.title} className="w-full aspect-[5/4] object-cover" />
              </div>
            </div>
            <div className="md:col-span-5">
              <p className="overline">{s.price}</p>
              <h2 className="font-heading text-4xl sm:text-5xl font-light tracking-[-0.01em] mt-3 leading-[1.05]">{s.title}</h2>
              <p className="mt-6 text-[#5C5752] leading-[1.9] font-light">{s.desc}</p>
              <ul className="mt-8 grid grid-cols-1 gap-3">
                {s.scope.map((x) => (
                  <li key={x} className="flex items-center gap-3 text-sm">
                    <span className="h-6 w-6 rounded-full bg-[#F5F0E6] grid place-items-center"><Check size={12} className="text-[#A07F2D]" strokeWidth={2.5} /></span>
                    <span>{x}</span>
                  </li>
                ))}
              </ul>
              <Link to="/book" data-testid={`service-cta-${i}`} className="btn-primary mt-10">
                Enquire <ArrowRight size={14} />
              </Link>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
